import { defineStore } from 'pinia';
import type { IBonusPage } from '~/types';

type Maybe<T> = T | null | undefined;

interface IPageContent<T> {
  currentLocaleData: Maybe<T>;
  defaultLocaleData: Maybe<T>;
}

export const useBonusContentStore = defineStore('bonusContent', () => {
  const content = ref<IPageContent<IBonusPage> | null>(null);
  const contentMap = ref<Record<string, IPageContent<IBonusPage>>>({});
  const loading = ref(false);

  function getContent(key: string): IPageContent<IBonusPage> | undefined {
    return contentMap.value[key];
  }

  function setContent(key: string, data: IPageContent<IBonusPage>) {
    contentMap.value[key] = data;
  }

  async function loadContent(pageIdentity: string) {
    const key = `bonus-page-${pageIdentity}`;
    const cached = getContent(key);

    if (cached) {
      content.value = cached;
      return;
    }

    loading.value = true;

    const { getContentData } = useContentLogic<IBonusPage>({
      contentKey: `${pageIdentity}-bonus-content`,
      contentRoute: ['bonus', pageIdentity],
      isPage: true,
    });

    const result = await getContentData();
    setContent(key, result);
    content.value = result;
    loading.value = false;
  }

  return {
    content,
    loading,
    loadContent,
  };
});
